/**
 * AULA del alumno para UNA cohorte (A1). URL-direccionable: el enlace de un
 * anuncio o de una notificación puede abrir el aula directamente.
 */
import { createRoute, useParams } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { StudentClassroomView } from "@/features/academy/components/classroom/student-classroom-view";

function StudentClassroomPage() {
  const params = useParams({ from: "/u/$u/classroom/$cohortId" });
  return <StudentClassroomView cohortId={params().cohortId} />;
}

export const classroomDetailRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/classroom/$cohortId",
  component: StudentClassroomPage,
});
